import * as actions from "./actions";

let initialState = {
  statisticsDayData: { data: [], fetching: false, fetched: false },
  statisticsRangeData: {
    data: [],
    fetching: false,
    fetched: false,
    calculated: false,
  },
  depotsDayData: { data: [], fetching: false, fetched: false },
  depotsRangeData: { data: [], fetching: false, fetched: false },
};

const home = (state = initialState, action) => {
  switch (action.type) {
    case actions.STATISTICS_REQUEST:
      return Object.assign({}, state, {
        statisticsDayData: Object.assign({}, state.statisticsDayData, {
          fetching: true,
        }),
      });

    case actions.STATISTICS_SUCCESS:
      return Object.assign({}, state, {
        statisticsDayData: Object.assign({}, state.statisticsDayData, {
          data: action.response,
          fetched: true,
          fetching: false,
        }),
      });

    case actions.DEPOT_REQUEST:
      return Object.assign({}, state, {
        statisticsDayData: Object.assign({}, state.depotsDayData, {
          fetching: true,
        }),
      });

    case actions.DEPOT_SUCCESS:
      return Object.assign({}, state, {
        depotsDayData: Object.assign({}, state.depotsDayData, {
          data: action.response,
          fetched: true,
          fetching: false,
        }),
      });

    case actions.DEPOT_RANGE_REQUEST:
      return Object.assign({}, state, {
        statisticsDayData: Object.assign({}, state.depotsRangeData, {
          fetching: true,
        }),
      });

    case actions.DEPOT_RANGE_SUCCESS:
      return Object.assign({}, state, {
        depotsRangeData: Object.assign({}, state.depotsRangeData, {
          data: action.response,
          fetched: true,
          fetching: false,
        }),
      });

    default:
      return state;
  }
};

export default home;
